import tinycolor from 'tinycolor2';

export function flattenColor(foreground: string, background?: string) {
  if (!background) {
    return foreground;
  }

  const fg = tinycolor(foreground).toRgb();
  const bg = tinycolor(background).toRgb();

  const r = Math.round(fg.r * fg.a + bg.r * (1 - fg.a));
  const g = Math.round(fg.g * fg.a + bg.g * (1 - fg.a));
  const b = Math.round(fg.b * fg.a + bg.b * (1 - fg.a));

  return tinycolor({ r, g, b }).toHexString();
}
